<template>
  <div>
    <v-chip :color="statusColor" text-color="white">
      <v-avatar left>
        <v-icon>{{ statusIcon }}</v-icon>
      </v-avatar>
      {{ statusLabel }}
    </v-chip>
  </div>
</template>

<script>
export default {
  name: "PaymentStatus",
  props: {
    order: {
      type: Object,
      required: true,
    },
  },
  computed: {
    statusColor: function () {
      if (this.order.payment == "offline") {
        if (this.order.payment_status == "preauth") {
          return "orange";
        } else if (this.order.payment_status == "confirmed") {
          return "success";
        }
      }

      switch (this.order.payment_status) {
        case "preauth":
          return "success";
        case "confirmed":
          return "success";
        case "refunded":
          return "orange";
        default:
          return "red";
      }
    },
    statusIcon: function () {
      if (this.order.payment == "offline") {
        if (this.order.payment_status == "preauth") {
          return "mdi-alert-circle";
        } else if (this.order.payment_status == "confirmed") {
          return "mdi-check";
        }
      }

      switch (this.order.payment_status) {
        case "preauth":
          return "mdi-check";
        case "confirmed":
          return "mdi-check";
        default:
          return "mdi-alert-circle";
      }
    },
    statusLabel: function () {
      if (this.order.payment == "offline") {
        if (this.order.payment_status == "preauth") {
          return "Venter betaling";
        } else if (this.order.payment_status == "confirmed") {
          return "Betalt";
        }
      }

      switch (this.order.payment_status) {
        case "preauth":
          return "Autorisert";
        case "confirmed":
          return "Bekreftet";
        case "refunded":
          return "Refundert";
        case "rejected":
          return "Avslått";
        case "input":
          return "Ikke fullført";
        default:
          return "Ukjent";
      }
    },
  },
};
</script>
